/* eslint-disable max-len */
const React = require('react');

const Dark = () => (
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.9946 25.5C19.8955 25.5 25.4893 19.9033 25.4893 13C25.4893 6.09665 19.8955 0.5 12.9946 0.5C6.09383 0.5 0.5 6.09665 0.5 13C0.5 19.9033 6.09383 25.5 12.9946 25.5Z" fill="#151B27" stroke="#BFBFBF" />
    <path d="M24.25 13C24.25 18.252 20.6522 22.6648 15.7873 23.9032C14.7876 24.1577 13.7538 23.3135 13.7527 22.002L13.7446 13.0007V12.9993L13.7527 3.99799C13.7538 2.68653 14.7876 1.84227 15.7873 2.09676C20.6522 3.33523 24.25 7.74805 24.25 13Z" fill="#4FE0D5" stroke="#151B27" strokeWidth="1.5" />
  </svg>
);

module.exports = Dark;
